import { useEffect, useState } from "react";
import React from "react";

import Spinner from "../Spinner/Spinner";

const InstallmentProductDetail = (props) => {
  const [showCost, setShowCost] = useState(false);
  useEffect(() => {
    setShowCost(true);
  }, [props.cost]);

  return (
    <>
      {props.loading ? (
        <Spinner />
      ) : (
        <div className="installmentDetails">
          <div className="innerInstallmentDetails">
            {showCost && (
              <>
                <div className="innerRows">
                  <div>
                    <span className="mainSpan">قیمت خود محصول : </span>
                  </div>
                  <div className="secMainSpan">
                    <span>{props.cost.price.toLocaleString()}&nbsp;</span>
                    <span>تومان</span>
                  </div>
                </div>
                <div className="innerRows">
                  <div>
                    <span className="mainSpan">سود :</span>
                  </div>
                  <div className="secMainSpan">
                    <span>{props.cost.monthly_profit}&nbsp;</span>
                    <span>درصد</span>
                  </div>
                </div>
                <div className="innerRows">
                  <div>
                    <span className="mainSpan">تعداد ماه اقساط :</span>
                  </div>
                  <div className="secMainSpan">
                    <span>{props.cost.month}&nbsp;</span>
                    <span>ماه</span>
                  </div>
                </div>
                <div className="innerRows">
                  <div>
                    <span className="mainSpan">پرداخت ماهیانه :</span>
                  </div>
                  <div className="secMainSpan">
                    <span>
                      {props.cost.monthly_payment.toLocaleString()}&nbsp;
                    </span>
                    <span>تومان</span>
                  </div>
                </div>
                <div className="innerRows">
                  <div>
                    <span className="mainSpan">هزینه نصب :</span>
                  </div>
                  <div className="secMainSpan">
                    <span>
                      {props.cost.installation_costs.toLocaleString()}&nbsp;
                    </span>
                    <span>تومان</span>
                  </div>
                </div>
                <div className="innerRows">
                  <div>
                    <span className="mainSpan">قیمت نهایی :</span>
                  </div>
                  <div className="secMainSpan">
                    <span>{props.cost.total_price.toLocaleString()}&nbsp;</span>
                    <span>تومان</span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InstallmentProductDetail;
